import useTranslation from 'next-translate/useTranslation';

import OnboardingWidget from '../OnboardingWidget';

export function NoActiveContests({
  onCacClick,
  onFinalContestsClick,
  isFullScreen,
  isWide,
}: {
  onCacClick: () => void;
  onFinalContestsClick: () => void;
  isFullScreen?: boolean;
  isWide?: boolean;
}) {
  const { t } = useTranslation('commissioner');

  return (
    <OnboardingWidget
      title={t('onboardingWidget.noActiveContests.title')}
      description={t('onboardingWidget.noActiveContests.description')}
      primaryButtonText={t('onboardingWidget.noActiveContests.primaryButtonText')}
      secondaryButtonText={t('onboardingWidget.noActiveContests.secondaryButtonText')}
      onPrimaryButtonClick={onCacClick}
      onSecondaryButtonClick={onFinalContestsClick}
      isFullScreen={isFullScreen}
      isWide={isWide}
    />
  );
}
